import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

export type FeatureBadgeKind = "new" | "soon";

// A "New" / "Soon" pill overlapping the top-right corner of the nearest positioned ancestor,
// or, `inline`, in the text flow after a label inside a container that clips overflow.
@Component({
  selector: "app-feature-badge",
  templateUrl: "./feature-badge.component.html",
  styleUrls: ["./feature-badge.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class.feature-badge--new]": "kind() === 'new'",
    "[class.feature-badge--soon]": "kind() === 'soon'",
    "[class.feature-badge--inline]": "inline()",
    "data-cy": "feature-badge",
  },
})
export class FeatureBadgeComponent {
  readonly kind = input.required<FeatureBadgeKind>();
  readonly inline = input(false);

  public readonly label = computed(() =>
    this.kind() === "new" ? "New" : "Soon",
  );
}
